import axios from 'axios';
import {API} from "@/services/url";
import qs from 'qs';

export default {
	getOfficeList : function (success, error) {
		axios.get(API.office.officeList)
			.then(r => success(r.data.officeList))
			.catch(e => error(e.response.data.message));
	},
	getOfficeListForProvidentFund : function (success, error) {
		axios.get(API.office.officeListForPF)
			.then(r => success(r.data.officeList))
			.catch(e => error(e.response.data.message));
	},
	getEmployeeList : function (officeId, success, error){
		axios.get(API.employee.employeeList+officeId)
			.then(r => success(r.data.employees))
			.catch(e => error(e.response.data.message))
	},
	getModuleListForOffice : function (officeId,success, error) {
		axios.get(API.office.officeList+officeId)
			.then(r => success(r.data.officeModuleList))
			.catch(e => error(e.response.data.message));

	},
	updateModuleListForOffice : function (officeId,data,success, error) {
		axios.post(API.office.officeList + officeId + API.office.updateModule, data)
			.then(r => success(r.data.officeModuleList))
			.catch(e => error(e.response.data.message));

	},
	createNewOffice : function (data, success, error) {
		axios.post(API.office.create, data)
			.then(r => success(r.data.officeList))
			.catch(e => error(e.response.data.message));
	},
	getOfficesByProjectIdList : function (projectIdList, success, error) {
		axios.get(API.office.getByProjectIdList, {
			params: {
				projectIdList: projectIdList
			},
			paramsSerializer: function(params) {
				return qs.stringify(params, {arrayFormat: 'repeat'})
			}
		})
			.then(r => success(r.data.officeList))
			.catch(e => error(e.response.data.message));
	},

	sendPayrollActivationEmail : function (data, success, error) {
		axios.post(API.office.sendPayrollActivationEmail, data)
			.then(r => success())
			.catch(e => error());
	},
	updateManagerOrApproverConfiguration : function (employeeId,data,success, error) {
		console.log(data);
		axios.post(API.employee.updateManagerOrApproverConfig + employeeId, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));

	},
	setEmployeeRole: function (employeeId, data, success, error){
		axios.post(API.employee.setEmployeeRole + employeeId, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getPayrollStaffList: function (officeId, success, error){
		axios.get(API.employee.existingPayrollStaff + officeId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	removePayrollStaff: function (employeeId, success, error){
		axios.get(API.employee.removePayrollStaff + employeeId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getDevicesOfAnOffice: function (officeId, success, error) {
		axios.get(API.office.deviceList + officeId)
			.then(r => success(r.data.devices) )
			.catch(e => error(e.response.data.message));
	}
}
